import { render, staticRenderFns } from "./BoostingInvitations.vue?vue&type=template&id=08f91b5e&scoped=true&"
import script from "./BoostingInvitations.vue?vue&type=script&lang=js&"
export * from "./BoostingInvitations.vue?vue&type=script&lang=js&"
import style0 from "./BoostingInvitations.vue?vue&type=style&index=0&id=08f91b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f91b5e",
  null
  
)

export default component.exports